export default __webpack_public_path__ + "static/media/home_header.0a66b85a.png";